/** Företagets besöks-/lageradress – fallback när system_settings.company_address saknas. */
export const COMPANY_LOCATION = {
  street: 'Lockarpsvägen 6B',
  postalCode: '213 76',
  locality: 'Malmö',
  region: 'Skåne',
  country: 'SE',
  fullAddress: 'Lockarpsvägen 6B, 213 76 Malmö',
  latitude: 55.5956,
  longitude: 13.0431,
  mapsUrl: 'https://www.google.com/maps/place/Lockarpsvägen+6B,+213+76+Malmö',
  buildingImageUrl: '/company/lockarpsvagen-vita-huset.png',
} as const;

export function resolveCompanyAddress(settingsAddress?: string | null): string {
  const trimmed = String(settingsAddress ?? '').trim();
  return trimmed || COMPANY_LOCATION.fullAddress;
}
